// shared humanized labels for vehicle wash/maint statuses. chips, edit
// selects, and history rows across the ops surfaces must agree on these.
// PM and OOS stay uppercase; everything else is sentence case. the dvir
// statuses drop the "DVIR" suffix in their label: the maint column is already
// understood as the dvir column, so the acronym only cost width on the narrow
// mobile card. the ACRONYMS list below still uppercases DVIR for any unmapped
// value that falls through to the fallback. which statuses a given surface
// OFFERS stays a per-surface decision (the board includes OOS, the vsm select
// trims by washed_enabled); only the label text is shared.

const ACRONYMS = ['PM', 'OOS', 'DVIR']

export const VEHICLE_STATUS_LABELS = {
    READY: 'Ready',
    CLEANED: 'Clean',
    WASHED: 'Washed',
    DIRTY: 'Dirty',
    OUT: 'Out',
    OOS: 'OOS',
    PM: 'PM',
    PENDING_DVIR: 'Pending',
    UNSAFE_DVIR: 'Unsafe',
}

// fallback for values outside the map: underscores to spaces, sentence
// case per word, acronyms preserved
export const statusLabel = value => {
    if (!value) return ''
    const known = VEHICLE_STATUS_LABELS[value]
    if (known) return known
    return String(value)
        .split(/[_\s]+/)
        .map(w => ACRONYMS.includes(w.toUpperCase())
            ? w.toUpperCase()
            : w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ')
}

// b-form-select options for a list of status values
export const statusOptions = values => values.map(v => ({ value: v, text: statusLabel(v) }))
